import styled from "styled-components";
import { Paper } from "@material-ui/core";
import { lightBlack, MainTableRow } from "../shared/Style/Style";

export const TrainersTableHeader = styled(MainTableRow)`
  grid-template-columns: 0.8fr 1.4fr 0.6fr 0.2fr;
  grid-gap: 10px;
  align-items: center;
  justify-content: start;
`;

export const TrainersListItem = styled(TrainersTableHeader)`
  min-height: 80px;
`;

export const TrainerContainer = styled(Paper)`
  margin: 40px 0px;
  padding: 20px 40px;
`;

export const FormBlocksContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const TrainerBlock = styled.div`
  width: 50%;
  padding-right: 40px;
  border-right: 2px solid #C4C4C4;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
  
export const BundlesBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin: 40px auto;
`;

export const ImagesBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

export const ImagesTitle = styled.span`
  color: ${lightBlack};
  font-size: 14px;
  line-height: 36px;
`;
